import Box from 'ui/src/components/Box'
import Stack from 'ui/src/components/Stack'
import Typography from 'ui/src/components/Typography'
import { useTranslation } from 'react-i18next'
import LogoCircle from 'ui/src/assets/images/ProtexxaLogos/ProtexxaSymbole-circle.svg?react'

const AppLoading = () => {
  const { t } = useTranslation()

  return (
    <Stack
      sx={{
        height: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <LogoCircle />
      <Box
        sx={{
          mt: 2,
        }}
      >
        {/* due to loading times we're using hex color code here */}
        <Typography
          variant="h6"
          sx={{
            fontWeight: '500',
            color: '#004090',
          }}
        >
          {t('app.loading')}...
        </Typography>
      </Box>
    </Stack>
  )
}

export default AppLoading
